import * as React from "react";

import { cn } from "./utils";

function Card({
  className,
  interactive = false,
  ...props
}: React.ComponentProps<"div"> & { interactive?: boolean }) {
  return (
    <div
      data-slot="card"
      className={cn(
        // `text-primary` here tinted every uncoloured descendant brand-orange ,
        // form labels, body copy, textarea content, stat values , because none of
        // those set a colour of their own. Cards carry normal foreground text.
        "mnrq-card flex flex-col rounded-[var(--radius-lg)] border border-[var(--color-border-default)] bg-background text-card-foreground shadow-[var(--shadow-xs)]",
        interactive
          ? "cursor-pointer transition-[background-color,box-shadow,border-color,transform] duration-[var(--duration-default)] ease-[var(--ease-default)] hover:-translate-y-0.5 hover:bg-[var(--color-bg-surface-hover)] hover:shadow-[var(--shadow-md)]"
          : "",
        className,
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-4 pt-4 sm:px-5 sm:pt-5 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-4",
        className,
      )}
      {...props}
    />
  );
}

function CardTitle({
  className,
  headingLevel = "h4",
  ...props
}: React.ComponentProps<"div"> & { headingLevel?: "h2" | "h3" | "h4" }) {
  const Heading = headingLevel;
  return (
    <Heading
      data-slot="card-title"
      className={cn("text-base font-semibold leading-[1.4] tracking-[-0.01em] text-foreground", className)}
      {...props}
    />
  );
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <p
      data-slot="card-description"
      className={cn("text-sm leading-[1.6] text-[var(--color-text-secondary)]", className)}
      {...props}
    />
  );
}

function CardAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-action"
      className={cn(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        className,
      )}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn("px-4 sm:px-5 [&:last-child]:pb-4 sm:[&:last-child]:pb-5", className)}
      {...props}
    />
  );
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn("flex items-center px-4 pb-4 sm:px-5 sm:pb-5 [.border-t]:pt-4", className)}
      {...props}
    />
  );
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
};
